function TouchSwipe(opts) {
  const obj = this;
  const dft = {
    delta: 100,
    velocity: 0.5,
    tolerance: 10,
    mouse: false,
    touch: true,
    scroll: true,
  };
  obj.opts = Object.assign({}, dft, opts);
  obj.cbs = {
    touchstart: function(e) {
      if (e.touches.length > 1) return;
      obj.start = posInfo(e);
    },
    touchmove: function(e) {
      if (e.touches.length > 1 || obj.fired()) return;
      const p = obj.last = posEval.bind(obj)(posInfo(e));
      if (obj.opts.delta <= p.dh
        && obj.opts.velocity <= p.velocity
        && !obj.scrolling
        && p.direction) {
        obj.last.fired = true;
        obj.trigger(p.direction);
      }
      // console.log(p.direction, p.velocity, p.dh, p.angle, obj.opts.tolerance, obj.scrolling);
    },
    touchend: function(e) {
      if (e.touches.length >= 1) return;
      obj.start = null;
      obj.last = null;
      obj.scrolling = null;
    },
    scroll: function(e) {
      if (obj.scrolling) {
        clearTimeout(obj.scrolling);
        obj.scrolling = null;
      }
      if (obj.opts.scroll) {
        obj.scrolling = setTimeout(function() {
          obj.scrolling = null;
        }, 100);
      }
    },
  };
  return this;
}
const ts = TouchSwipe;
const tsp = ts.prototype;

tsp.on = function(op) {
  if (!op) op = 'add';
  Object.keys(this.cbs).forEach(n => {
    document[op + 'EventListener'](n, this.cbs[n], { capture: true });
  });
};
tsp.off = function() { this.on('remove'); };

tsp.fired = function() { return this.last && this.last.fired; };
tsp.trigger = function(dir) {
  const cb = this.opts['on' + dir];
  // console.log(dir, cb, this);
  if (typeof cb === 'function') cb(this.last, this);
};

function posInfo(e) {
  if (e && e.touches && e.touches.length === 1) {
    return {
      time: Date.now(),
      x: e.touches[0].clientX,
      y: e.touches[0].clientY,
    };
  }
}
function posEval(current) {
  const start = this.start;
  const rv = { start, current };
  rv.ms = current.time - start.time;
  rv.dx = current.x - start.x;
  rv.dy = current.y - start.y;
  rv.dh = Math.sqrt(rv.dx * rv.dx + rv.dy * rv.dy);
  rv.velocity = rv.dh / rv.ms;
  rv.angle = rv.dx === 0 ? 90 : Math.abs(Math.atan(rv.dy / rv.dx) * 180 / Math.PI);
  if (Math.abs(rv.angle - 90) <= this.opts.tolerance) {
    rv.direction = rv.dy < 0 ? 'up' : 'down';
  } else if (rv.angle <= this.opts.tolerance) {
    rv.direction = rv.dx > 0 ? 'right' : 'left';
  }
  return rv;
}

export default TouchSwipe;
